
 <div class="main-wrapper">
        <div class="main-content">
            <header>

                <div class="head-line">

                    <p>Mail Send Status</p>


                </div>
                <div class="user-wrapper">
                    <p>{{storedData.agencyRefId.agencyName}}</p>

                    <div>
                        <img class="log1"
                            [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/../../assets/images/user1.jpeg'">
                    </div>
                </div>
            </header>

                <!-- email-progress.component.html -->
                <div class="email-progress-container">
                <h2>Email Sending Progress</h2>

                <div class="progress-box">
                    <div class="progress-info">
                    <p><strong>Total:</strong> {{ totalCount }}</p>
                    <p><strong>Sent:</strong> {{ sentCount }} / {{ totalCount }}</p>
                    <p><strong>Failed:</strong> {{ failedCount}} /{{ totalCount }}</p>
                    </div>

                    <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="progress"></div>
                    </div>
                </div>

                <!-- <div class="controls">
                    <button (click)="startSending()" [disabled]="isSending">Start Sending</button>
                    <button (click)="cancelSending()" *ngIf="isSending">Cancel</button>
                </div> -->
                </div>
        </div>
 </div>